import React, { useState } from 'react'
import { Button, Input, Modal, Form, Radio, Space, Toast } from 'antd-mobile-v5'
import { WhiteSpace } from 'antd-mobile'
import { useHistory } from 'react-router-dom';
import { FormattedMessage, useIntl } from 'react-intl';
import { useRenewCouponTransfer } from '../../services/hooks'

import styles from './RenewCouponsList.module.css'

const CouponStatus = ({ coupon, refreshList }) => {

  const { push } = useHistory()
  const { formatMessage } = useIntl()
  const [visible, setVisible] = useState(false)
  const { runAsync: toTransferRequest, loading } = useRenewCouponTransfer();

  const onFinish = (values) => {
    const { couponId, couponType } = coupon
    const submitData = {
      ...values,
      couponId: couponId,
      CouponType: couponType,
    }
    toTransferRequest(submitData).then(res => {
      if (res) {
        Toast.show({
          icon: 'success',
          content: formatMessage({ id: 'renew-coupon-transfer-success' }),
          afterClose: () => {
            refreshList()
            setVisible(false)
          }
        })
      }
    })
  }

  if(coupon.expired) {
    return <span className={styles.expired}><FormattedMessage id='renew-coupon-expired' /></span>
  }else if(coupon.used) {
    return <span className={styles.used}><FormattedMessage id='renew-coupon-used' /></span>
  }else {
    return <>
      <Button size='mini' color='primary' fill='outline' onClick={() => push('/bookSaleList')}>
        <FormattedMessage id='renew-coupon-use' />
      </Button>
      <WhiteSpace />
      <Button size='mini' color='primary' fill='outline' onClick={() => setVisible(true)}>
        <FormattedMessage id='renew-coupon-transfer' />
      </Button>
      <Modal
        title={formatMessage({ id: 'renew-coupon-transfer-info' })}
        visible={visible}
        content={
          <Form
            footer={
              <>
                <Button block type='submit' color='primary' size='large' loading={loading}>
                  <FormattedMessage id='renew-coupon-confirm-transfer' />
                </Button>
                <WhiteSpace />
                <Button block fill='none' size='small' onClick={() => setVisible(false)}>
                  <FormattedMessage id='renew-coupon-cancel-transfer' />
                </Button>
              </>
            }
            onFinish={onFinish}
          >
            <Form.Header><FormattedMessage id='renew-coupon-transfer-tips' /></Form.Header>
            <Form.Item 
              name='userType' 
              label={formatMessage({ id: 'renew-coupon-member-type' })}
              required
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: 'renew-coupon-member-type-error' }),
                },
              ]}>
              <Radio.Group>
                <Space direction='vertical'>
                  <Radio value='INSTRUCTOR'><FormattedMessage id='certdetail-instructorInfo' /></Radio>
                  <Radio value='STORE'><FormattedMessage id='certdetail-storeMsg' /></Radio>
                </Space>
              </Radio.Group>
            </Form.Item>
            <Form.Item 
              name='memberNumber' 
              label={formatMessage({ id: 'si-cd-instructor-num' })} 
              required
              rules={[
                {
                  required: true,
                  message: formatMessage({ id: 'si-cd-instructor-num-tip' })
                },
              ]}>
              <Input placeholder='请输入' type="number" />
            </Form.Item>
          </Form>
        }
      />
    </>
  }
}

export default CouponStatus